var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 16H16V496H176V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176 16V496H336H496V16H336H176Z",
    fill: "#8D1B3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.628 16V496H210.52L235.134 469.35L210.52 442.65L235.134 416L210.52 389.35L235.134 362.65L210.52 336L235.134 309.35L210.52 282.65L235.134 256L210.52 229.35L235.134 202.65L210.52 176L235.134 149.35L210.52 122.65L235.134 96L210.52 69.35L235.134 42.65L210.52 16H113.628H113.628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/QA.842559c893dd90f3bf149467b620ef42.svg";
export { ForwardRef as ReactComponent };